// extracted by mini-css-extract-plugin
export default {"form":"Forms_form__5M0j-","actionSidebarForm":"Forms_actionSidebarForm__j3h9E"};